import { render, staticRenderFns } from "./Cotacao.vue?vue&type=template&id=6a14bc60"
import script from "./Cotacao.vue?vue&type=script&lang=js"
export * from "./Cotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports